import Cars4SalePage from "./Cars4SalePage"

const filterTrimEl = document.getElementById('filter-trim')
const filterTrimMainEl = document.getElementById('filter-trim-main')
const yearSectionEl = document.getElementById('year-section')
const loanCalculatorApplyEl = document.getElementById('loan-calculator-apply')
const searchButton = document.querySelectorAll('.js-filters-search')

if (window.location.pathname.indexOf('/cars-for-sale') > -1) {
    
    // Input Handlers
    document.addEventListener('change', async (event) => {
        let p = event.target
        let input = ((p as HTMLElement).closest('#filters-form input, #filters-form select') as HTMLInputElement)

        // If input in the filter form was changed
        if (input && input.disabled === false)
            await refreshData(input)
    })

    searchButton?.forEach(item => {
        item.addEventListener('click', async () => {
            await refreshData(null)
        })
    })

    loanCalculatorApplyEl?.addEventListener('click', async () => {
        await refreshData(null)
    })

    document.addEventListener('click', function (event) {
        let el = event.target as HTMLElement;
        const filters = document.querySelectorAll<HTMLElement>('.js-filters');
        
        // Check for clicks on filtersClose elements
        if (el.closest('.js-filters-close')) {
            event.preventDefault();

            const currentFilters = document.querySelector('.js-filters');
            currentFilters?.classList.remove('is-active');
            currentFilters?.classList.add('hidden');

            document.body.classList.remove('has-open-filters');

            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        }

        // Check for clicks on filtersTrigger elements
        if (el.closest('.js-filters-trigger')) {
            event.preventDefault();

            filters.forEach((filter) => {
                filter.classList.remove('hidden');
            });

            setTimeout(() => {
                filters.forEach((filter) => {
                    filter.classList.add('is-active');
                });
            }, 0);

            document.body.classList.add('has-open-filters');
        }

        // Check for clicks on filtersClear elements
        if (el.closest('.js-filters-clear')) {
            event.preventDefault();

            const filtersElement = el.closest<HTMLElement>('.js-filters');
            if (filtersElement)
                clearFilters(filtersElement);

            refreshData(null)
        }

        // Handling click outside of .js-filters-content to close the filter
        //if (!el.closest('.js-filters-content')) {
        //    filters.forEach((filter) => {
        //        if (filter.classList.contains('is-active')) {
        //            filter.classList.remove('is-active');
        //            document.body.classList.remove('has-open-filters');
        //        }
        //    });
        //}
    });
}
function clearFilters(filtersElement: HTMLElement) {
    const checkboxes = filtersElement.querySelectorAll<HTMLFormElement>('input[type="checkbox"]');
    checkboxes.forEach((checkbox) => {
        checkbox.checked = false;
    });
}

async function refreshData(cb: HTMLInputElement | null) {
    let data = await getFilterData()
    console.log(data)

    // Load Models
    if (cb?.name == 'Make') {
        handleMakeChange(cb, data)
    }

    // Load Trims
    if (cb?.name == 'Model') {
        handleModelChange(cb, data)
    }

    Cars4SalePage.refreshSlides(data)

    toggleTrimSection()
    toggleYearSection()
    toggleNoResults(data.totalCount)

    updateCounts(data)
}

function updateCounts(data: any) {
    document.querySelectorAll(`[data-name]`)?.forEach(item => item.innerHTML = '')

    data.makes?.forEach((item: { value: string, count: number }) => {
        let el = document.querySelector(`[data-name=Make][data-value="${item.value}"]`)
        if (el) el.innerHTML = '(' + item.count + ')'
    })

    data.models?.forEach((item: { value: string, count: number }) => {
        let el = document.querySelector(`[data-name=Model][data-value="${item.value}"]`)
        if (el) el.innerHTML = '(' + item.count + ')'
    })

    data.colors?.forEach((item: { value: string, count: number }) => {
        let el = document.querySelector(`[data-name=Color][data-value="${item.value}"]`)
        if (el) el.innerHTML = '(' + item.count + ')'
    })

    data.drivetrains?.forEach((item: { value: string, count: number }) => {
        let el = document.querySelector(`[data-name=Drivetrain][data-value="${item.value}"]`)
        if (el) el.innerHTML = '(' + item.count + ')'
    })

    data.fuelTypes?.forEach((item: { value: string, count: number }) => {
        let el = document.querySelector(`[data-name=EngineFuelType][data-value="${item.value}"]`)
        if (el) el.innerHTML = '(' + item.count + ')'
    })

    data.transmissions?.forEach((item: { value: string, count: number }) => {
        let el = document.querySelector(`[data-name=Transmission][data-value="${item.value}"]`)
        if (el) el.innerHTML = '(' + item.count + ')'
    })
}

async function getFilterData() {
    let parms = new FormData(Cars4SalePage.filtersForm)
    const response = await fetch('/cars-for-sale?handler=LoadPage', { method: 'POST', body: parms })
    let data = await response.json()

    return data;
}

async function getModels(make: string) {
    const response = await fetch('/cars-for-sale?handler=Models&Make=' + make)
    let data = (await response.json()) as Array<string>

    return data;
}

async function getTrims(make: string, model: string) {
    const response = await fetch(`/cars-for-sale?handler=Trims&Make=${make}&Model=${model}`)
    let data = (await response.json()) as Array<{ make: string, model: string, trim: string }>

    return data;
}

async function handleMakeChange(cb: HTMLInputElement, data: any) {
    if (cb.checked && data) {
        let make = cb.value
        let models = (await getModels(make)) as Array<string>

        // Get model HTML
        let html = `<div class='model-data ps-3 hidden peer-checked:block'>`

        for (let z = 0; z < models?.length; z++) {
            // Get matching data item
            let di = data.models?.filter((m: { value: string, count: number }) => m.value == models[z])
            console.log(di)

            let uniqueId = make + models[z].replace(/\W+/g, '')

            html += getLIItem(make, models[z], uniqueId, di?.[0]?.count, 'Model')
        }

        html += `</div>`

        cb.parentElement?.insertAdjacentHTML('beforeend', html)
    }
    else {
        // Remove from DOM
        cb.parentElement?.querySelectorAll('.model-data')?.forEach(item => item.remove())
    }
}

async function handleModelChange(cb: HTMLInputElement, data: any) {
    let make = cb.getAttribute('data-make') as string
    let model = cb.value

    if (cb.checked && data) {
        let trims = (await getTrims(make, model)) as Array<{ make: string, model: string, trim: string }>
        console.log(trims)

        let html = `<div class='trim-item' data-make='${make}' data-model='${model}'>
                    <h5 class="font-inter text-primary mb-2">${make} ${model}</h5>
                    <div class="grid grid-cols-2 gap-8 gap-y-4 mb-6 list-none">`

        for (let z = 0; z < trims?.length ; z++) {
            // Get matching data item
            let di = data.trims?.filter((m: { value: string, count: number }) => m.value == trims[z].trim)
            console.log(di)

            let uniqueId = trims[z].trim.replace(/\W+/g, '')

            html += getLIItem('', trims[z].trim, uniqueId, di?.[0]?.count, 'Trim')
        }

        html += `</div></div>`

        filterTrimEl?.insertAdjacentHTML('beforeend', html)
    }
    else {
        // Remove from DOM
        document.querySelectorAll(`.trim-item[data-make="${make}"][data-model="${model}"]`)?.forEach(m => m.remove())
    }
}

const getLIItem = (make: string, value: string, uniqueId: string, count: number, name: string) => {
    let html = `<div class="pt-1">
            <input type="checkbox" name="${name}" data-make="${make}" value="${value}" id="filter-car-${name}-${uniqueId}" class="absolute top-0 left-0 opacity-0 peer" />
            <label for="filter-car-${name}-${uniqueId}" class="relative flex items-center gap-4 after:w-8 after:h-8 after:border after:border-blue-2 after:rounded-md after:bg-blue-2 after:absolute after:top-1/2 after:-translate-y-1/2 after:left-0 after:bg-white-check after:bg-no-repeat after:bg-center after:bg-cover after:transition duration-300 after:opacity-0 peer-checked:after:opacity-100">
                <span class="w-8 h-8 block border border-gray-2 rounded-md bg-white"></span>
                <span class="flex-1">${value} `

    if (count) {
        html += `<span data-name="${name}" data-value="${value}" class="italic text-sky-400">(${count})</span>`
    }

    html += `</span>
            </label>
        </div>`

    return html
}

function toggleNoResults(count: number) {
    document.body.classList.toggle('no-cars', count == 0)
}

function toggleTrimSection() {
    let hasElements = document.querySelectorAll('input[name=Model]:checked')?.length > 0

    filterTrimMainEl?.classList.toggle('hidden', !hasElements)

    if (!hasElements && filterTrimEl)
        filterTrimEl.innerHTML = ''
}

function toggleYearSection() {
    let isNewChecked = document.querySelector('input[name=Condition][value=New]:checked') != null
    let isUsedChecked = document.querySelector('input[name=Condition][value=Used]:checked') != null

    yearSectionEl?.classList.toggle('hidden', isNewChecked && !isUsedChecked)
}